import React from 'react'

import {FilterLabels} from '../types/constEnums'
import {
  CUSTOMIZED_SVG,
  timelineEventTypeMenuIcons,
  timelineEventTypeMenuLabels
} from '../utils/constants'
import CardsSVG from './CardsSVG'
import MenuItemLabel from './MenuItemLabel'
import TimelineEventTypeIcon from './TimelineEventTypeIcon'





const EventTypeFilterMenuItemLabel = (props) => {
  const {eventType} = props
  const eventTypeLabel = eventType
    ? timelineEventTypeMenuLabels[eventType]
    : FilterLabels.ALL_EVENTS
  const eventTypeIconName = eventType ? timelineEventTypeMenuIcons[eventType] : 'timeline'
  return (
    React.createElement(React.Fragment, null
      , React.createElement('span', { className: "py-1 pl-4" ,}
        /* Update here if there are more customized SVGs than CardsSVG to display */
        , eventTypeIconName === CUSTOMIZED_SVG ? (
          React.createElement(CardsSVG, null )
        ) : (
          React.createElement(TimelineEventTypeIcon, { iconName: eventTypeIconName,} )
        )
      )
      , React.createElement(MenuItemLabel, null, eventTypeLabel)
    )
  )
}

export default EventTypeFilterMenuItemLabel
